import i from"../isNull/isNull.js";import e from"../isUndefined/isUndefined.js";function n(n){return i(n)||e(n)}export{n as default};
//# sourceMappingURL=isNullOrUndefined.js.map
